import * as React from 'react';
import { Spinner } from 'evergreen-ui';

function LoadingStateSpinner() {
  return <Spinner size={24} marginX="auto" paddingY={30} />;
}

export default LoadingStateSpinner;
